module.exports = __webpack_public_path__ + "static/media/speed.b77af2a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/speed.svg
// module id = 459
// module chunks = 0